import { Link, Metrics } from '@sparemin/blockhead';
import cn from 'classnames';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import useNotificationAlertSelector from 'hooks/useNotificationAlert';
import { onClickHomepageAnalyticsTab } from 'redux/modules/mixpanel';
import { updateNotificationAlert } from 'redux/modules/notification-alert';
import { MAKE_PAGE_DASHBOARD_URL } from 'utils/constants';
import { tabsBlock as block } from '../../utils';
import ProjectsTabTitle from './ProjectsTabTitle';

type AnalyticsTabTitleProps = {};

const AnalyticsTabTitle: React.FC<AnalyticsTabTitleProps> = () => {
  const dispatch = useDispatch();

  const { hasNewData } = useNotificationAlertSelector();

  const handleAnalyticsTabClick = useCallback(() => {
    dispatch(onClickHomepageAnalyticsTab());
    if (hasNewData) {
      dispatch(updateNotificationAlert({ hasNewSocialShareData: false }));
    }
  }, [dispatch, hasNewData]);

  return (
    <Link
      href={MAKE_PAGE_DASHBOARD_URL}
      target="__blank"
      rel="noopener noreferrer"
      className={cn(block('title-contents', { alert: hasNewData }))}
      onClick={handleAnalyticsTabClick}
    >
      <ProjectsTabTitle
        icon={<Metrics width={15} height={15} style={{ marginTop: 4 }} />}
        label="ANALYTICS"
      />
    </Link>
  );
};
export default AnalyticsTabTitle;
